import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { createNotice } from "../../../api/homepageManagementHomeNotice.api";
import ErrorResponse from "../../../components/ErrorResponse";
import NoticeEditor from "../../../components/homepage/notice/Editor";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";

const NoticeCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();

  useEffect(() => {
    if (res && !isLoading) {
      successNotification(t('common.message.save1'));
      history.push('/homepage/notice');
    }
  }, [res, isLoading]);

  const submit = (data: FormData) => {
    execute(createNotice(data));
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.notice.title2')}
      />
      <NoticeEditor
        submit={submit}
      />
    </div>
  );
}

export default NoticeCreate;
